import unfetch from '../src/index.mjs';
if (!self.fetch) self.fetch = unfetch;



// WEBPACK FOOTER //
// ./node_modules/unfetch/polyfill/polyfill.mjs